import { useCallback, useState } from 'react';
import { ToastOptions, toast } from "react-toastify";

type UseToastifyReturn = {
    errorToast: any;
    successToast: any;
    infoToast: any;
    dismissAll: () => void;
    toastOpenValue: boolean;
};

const useToastify = (): UseToastifyReturn => {
    const [toastOpenValue, setToastOpenValue] = useState<boolean>(false);
    // let toastId: any;

    const errorToast = (value = "Oops! Toast error", options?: ToastOptions) => {
        toast.error(value, {
            position: "bottom-left",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            ...options,
            onOpen: () => setToastOpenValue(true),
            onClose: () => setToastOpenValue(false),
            onClick: (e) => e.stopPropagation(),
        });

    };

    const successToast = (value = "Operation successful", options?: ToastOptions) => {

        toast.success(value, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            ...options,
            onOpen: () => setToastOpenValue(true),
            onClose: () => setToastOpenValue(false),
            onClick: (e) => e.stopPropagation(),
        });
    };

    const infoToast = (value = "Loading please wait...", options?: ToastOptions) => {
        // if (!toastId) {
        toast.info(value, {
            position: "bottom-left",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            ...options,
            onOpen: () => setToastOpenValue(true),
            onClose: () => setToastOpenValue(false),
            onClick: (e) => e.stopPropagation(),
        });
        // }
    };

    const dismissAll = useCallback(() => {
        toast.dismiss();
        setToastOpenValue(false);
        // toastId = undefined;
    }, []);

    return { errorToast, successToast, infoToast, dismissAll, toastOpenValue };
};

export default useToastify;
